module.exports = __webpack_public_path__ + "img/logo_light.7b0332cb.png";